import styled from '@emotion/styled';
import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { FC } from 'react';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { EventLogo } from '../../BasicComponents/EventLogo';
import { Buttons } from './Buttons';
import { EventMetaInfos } from './EventInfos';
import { PriceField } from './PriceField';

export const TitleBar: FC = () => {
  const event = useCurrentEvent();
  const user = useCurrentUser();
  if (event == null || user == null) return <></>;

  return (
    <Container id={TestSelectors.admin.eventEditor.titleBar.container.toString()}>
      <LogoBox>
        <EventLogo event={event} size={54} />
      </LogoBox>
      <EventMetaInfos event={event} />
      <PriceField event={event} />
      <Buttons event={event} />
    </Container>
  );
};

// Flush with the top, bottom and left edge of the bar.
const LogoBox = styled.div`
  flex: none;
  align-self: stretch;
  display: flex;
  overflow: hidden;

  div {
    border: none;
    height: 100%;
  }

  img {
    height: 100%;
    width: auto;
    margin: 0;
  }
`;

const Container = styled.div`
  position: fixed;
  top: 50px;
  left: 0px;
  right: 0px;
  height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  background-color: white;
  border-bottom: 1px solid #e7e7e7;
  padding: 0 10px 0 0;
  z-index: 1;
`;
